import { Analytics } from './analytics'

export enum MessageTemplateAnalyticsEvent {
   messageTemplateCreated = 'Message template created',
   messageTemplateEdited = 'Message template edited',
}

export namespace MessageTemplateAnalyticsParams {
   export type Created = {
      messageTemplateName: string
   }
   export type Edited = {
      messageTemplateName: string
   }
}

export default class MessageTemplateAnalytics implements Analytics {
   static created = (params: MessageTemplateAnalyticsParams.Created) => {
      return Analytics.emitEvent(MessageTemplateAnalyticsEvent.messageTemplateCreated, {
         'Message template name': params.messageTemplateName,
      })
   }

   static edited = (params: MessageTemplateAnalyticsParams.Edited) => {
      return Analytics.emitEvent(MessageTemplateAnalyticsEvent.messageTemplateEdited, {
         'Message template name': params.messageTemplateName,
      })
   }
}
